var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("display:inline-block;background: url('" + _vm.baseUrl + "assets/sprite.png') " + _vm.left + "px " + _vm.top + "px;\nwidth: " + _vm.width + "px; height: " + _vm.height + "px"))})}
var staticRenderFns = []

export { render, staticRenderFns }